<template>
    <el-drawer
      :visible="dialogVisible"
      direction="ltr"
      @close="close"
    >
      <div class="history-page">
        <div class="history-head">历史记录</div>
        <div class="history-input"><el-input v-model="input" placeholder="请输入关键词搜索" @keyup.enter.native="getPlaneErrorRecord(true)"></el-input></div>
        <div class="history-ul" @scroll="load($event)">
          <div class="history-li" v-for="item in errorRecordList" :key="item.id" >
            <div class="history-top">
              <div class="history-text">
                <div class="history-h" v-if="'' === item.result">当前事件正在处理中...</div>
                <div class="history-h" v-else>{{`机舱内${item.typeComment}事件`}}<span :class="resultColor(item)">{{resultComment(item)}}</span></div>
                <div class="history-p">{{item.createTimeFormat}}</div>
              </div>
              <div class="history-bt" :class="{active:'' === item.result}" @click="goMalfunction(item)">
                {{ '' === item.result?'立即进入':'进入查看' }}
              </div>
            </div>
            <div class="history-bottom">
              <div class="history-laber">
                <div class="history-left">记录编号</div>
                <div class="history-right">{{item.id}}</div>
              </div>
              <div class="history-laber">
                <div class="history-left">飞机类型</div>
                <div class="history-right">{{item.planeType}}</div>
              </div>
              <div class="history-laber">
                <div class="history-left">航班号</div>
                <div class="history-right">{{item.flightNo}}</div>
              </div>
              <div class="history-laber">
                <div class="history-left">飞机编号</div>
                <div class="history-right">{{item.planeId}}</div>
              </div>
            <!--  <div class="history-laber">
                <div class="history-left">结果</div>
                <div v-if="item.lastResult==='R1'" class="history-right active2">{{item.lastResultComment}}</div>
                <div v-if="item.lastResult==='R2'" class="history-right active">{{item.lastResultComment}}</div>
                <div v-if="item.lastResult==='R3'" class="history-right active3">{{item.lastResultComment}}</div>
                <div v-if="item.lastResult==='R4'" class="history-right active4">{{item.lastResultComment}}</div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
</template>

<script>
  import {pageKeCang} from "@/api/kecang";
  import {pageParsePlanAboutToVO} from "@/api/api";

  export default {
    props:{
      dialogVisible:{
        default:false
      },
      client:{
        type:String,
        required:true
      },
    },
    data() {
        return {
          input:'CSN',
          errorRecordList:[],
          query:{
            number: 1,
            limit: 10,
          },
          params:{
            search: null,
            orderBy:JSON.stringify([{"name":"id","direction":"DESC"}])
          },
          isScroll:true
        };
    },
    created() {
      this.getPlaneErrorRecord()
    },
    methods:{
      close(){
        this.$emit('handle-close')
      },
      goMalfunction(item) {
        if (['ROLE_SOC', 'ROLE_SCDR'].includes(this.client)) {
          this.$router.push(`/CabinEvent/${this.client}/${item.id}`)
        }
        this.close()
      },
      async getPlaneErrorRecord(search) {
        this.isScroll = false
        if(search){
          this.params.search = this.input === 'CSN' ? null : this.input
          this.query.number = 1
          const res = await pageKeCang(this.query,this.params)
          if(res.code === 'A00000' && res.data.length) {
            this.errorRecordList = res.data
          } else {
            this.errorRecordList = []
          }
        } else {
          const res = await pageKeCang(this.query,this.params)
          if(res.code === 'A00000' && res.data.length) {
            this.errorRecordList = [...this.errorRecordList, ...res.data]
            this.isScroll = true
            if(res.data.length < 10){
              this.isScroll = false
              //  this.$message.info('已全部加载完')
            }
          }
        }
      },
      load(e){
        const sHeight = e.target.scrollHeight
        const sTop = e.target.scrollTop
        const cHeight = e.target.clientHeight
        if(sTop + cHeight + 50 >=  sHeight && this.isScroll) {
          this.morePage()
        }
      },
      morePage() {
        this.query.number++
        this.getPlaneErrorRecord()
      },
      resultColor(row) {
        // return '' // 黄色
        // return 'active2' // 红色
        // return 'active3' // 蓝色
        // return 'active' // 绿色
        switch (row.type) {
          case 'CET0': // 纵火
            // R1("快速撤离", "请指挥旅客快速撤离，并随时监控是否出现明火，完成检查单项目。", new String[]{"确定出现试图纵火的行为", "无人员反馈到明火或烟雾"}),
            // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"出现客舱纵火行为", "可观察到明火或烟雾"}),
            // R3("公司决策", "", new String[]{}),
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R2' :
                return 'red' // 红色
              case 'R3' :
                return 'blue' // 蓝色
            }
            break
          case 'CET1': // 斗殴
            // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现斗殴的行为", "无人员反馈到严重的事态行为"}),
            // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现斗殴的行为", "已出现严重的事态行为"}),
            // R3("公司决策", "", new String[]{}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R2' :
                return 'red' // 红色
              case 'R3' :
                return 'blue' // 蓝色
              case 'R4' :
                return 'green' // 绿色
            }
            break
          case 'CET2': // 劫炸机威胁
            // R1("立即滑回防爆停机位", "请立即滑回防爆停机位，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"已出现严重的事态行为"}),
            // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"存在爆炸物风险"}),
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R2' :
                return 'red' // 红色
            }
            break
          case 'CET3': // 违规使用电子/应急设备
            // R1("创造条件起飞", "请尽可能创造起飞条件，并完成检查单项目。", new String[]{"确认违规使用电子/应急设备事件"}),
            // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确认违规使用电子/应急设备事件", "已出现影响通讯情况", "已出现故障警告情况", "已出现开启或损坏紧急设备情况"}),
            // R3("公司决策", "", new String[]{}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R2' :
                return 'red' // 红色
              case 'R3' :
                return 'blue' // 蓝色
              case 'R4' :
                return 'green' // 绿色
            }
            break
          case 'CET4': // 冲击驾驶舱
            // R1("立即滑回", "请立即滑回，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"确定出现冲击驾驶舱行为"}),
            // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现冲击驾驶舱行为", "已出现严重的事态行为"}),
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R2' :
                return 'red' // 红色
            }
            break
          case 'CET5': // 机上吸烟
            // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现机上吸烟行为", "无人员反馈到严重的事态行为"}),
            // R2("事件转变", "", new String[]{""}),
            // R3("-", "", new String[]{""}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R4' :
                return 'green' // 绿色
            }
            break
          case 'CET6': // 冲击机场/拒不下机
            // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现冲击机场拒不下机行为", "无人员反馈到严重的事态行为"}),
            // R2("事件转变", "", new String[]{""}),
            // R3("-", "", new String[]{""}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R4' :
                return 'green' // 绿色
            }
            break
          case 'CET7': // 劫炸机
            switch (row.result) {
              case 'R1' :
                return 'yellow' // 黄色
              case 'R2' :
                return 'red' // 红色
              case 'R3' :
                return 'blue' // 蓝色
            }
            break
        }
        return 'yellow'
      },
      resultComment(row) {
        switch (row.type) {
          case 'CET0': // 纵火
            // R1("快速撤离", "请指挥旅客快速撤离，并随时监控是否出现明火，完成检查单项目。", new String[]{"确定出现试图纵火的行为", "无人员反馈到明火或烟雾"}),
            // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"出现客舱纵火行为", "可观察到明火或烟雾"}),
            // R3("公司决策", "", new String[]{}),
            switch (row.result) {
              case 'R1' :
                return '快速撤离' // 黄色
              case 'R2' :
                return '紧急撤离' // 红色
              case 'R3' :
                return '公司决策' // 蓝色
            }
            break
          case 'CET1': // 斗殴
            // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现斗殴的行为", "无人员反馈到严重的事态行为"}),
            // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现斗殴的行为", "已出现严重的事态行为"}),
            // R3("公司决策", "", new String[]{}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return '创造起飞条件' // 黄色
              case 'R2' :
                return '滑回减员' // 红色
              case 'R3' :
                return '公司决策' // 蓝色
              case 'R4' :
                return '继续起飞' // 绿色
            }
            break
          case 'CET2': // 劫炸机威胁
            // R1("立即滑回防爆停机位", "请立即滑回防爆停机位，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"已出现严重的事态行为"}),
            // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"存在爆炸物风险"}),
            switch (row.result) {
              case 'R1' :
                return '立即滑回防爆停机位' // 黄色
              case 'R2' :
                return '紧急撤离' // 红色
            }
            break
          case 'CET3': // 违规使用电子/应急设备
            // R1("创造条件起飞", "请尽可能创造起飞条件，并完成检查单项目。", new String[]{"确认违规使用电子/应急设备事件"}),
            // R2("滑回减员", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确认违规使用电子/应急设备事件", "已出现影响通讯情况", "已出现故障警告情况", "已出现开启或损坏紧急设备情况"}),
            // R3("公司决策", "", new String[]{}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return '创造条件起飞' // 黄色
              case 'R2' :
                return '滑回减员' // 红色
              case 'R3' :
                return '公司决策' // 蓝色
              case 'R4' :
                return '继续起飞' // 绿色
            }
            break
          case 'CET4': // 冲击驾驶舱
            // R1("立即滑回", "请立即滑回，并随时监控是否出现秩序失控，完成检查单项目", new String[]{"确定出现冲击驾驶舱行为"}),
            // R2("紧急撤离", "基于以上风险请立刻指挥旅客紧急撤离当前航班。", new String[]{"确定出现冲击驾驶舱行为", "已出现严重的事态行为"}),
            switch (row.result) {
              case 'R1' :
                return '立即滑回' // 黄色
              case 'R2' :
                return '紧急撤离' // 红色
            }
            break
          case 'CET5': // 机上吸烟
            // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现机上吸烟行为", "无人员反馈到严重的事态行为"}),
            // R2("事件转变", "", new String[]{""}),
            // R3("-", "", new String[]{""}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return '创造起飞条件' // 黄色
              case 'R4' :
                return '继续起飞' // 绿色
            }
            break
          case 'CET6': // 冲击机场/拒不下机
            // R1("创造起飞条件", "请尽可能创造起飞条件，并随时监控是否出现秩序失控，完成检查单项目。", new String[]{"确定出现冲击机场拒不下机行为", "无人员反馈到严重的事态行为"}),
            // R2("事件转变", "", new String[]{""}),
            // R3("-", "", new String[]{""}),
            // R4("继续起飞", "", new String[]{"各角色顺利完成检查单任务", "目前事态已经控制并已恢复正常秩序"}),
            switch (row.result) {
              case 'R1' :
                return '创造起飞条件' // 黄色
              case 'R4' :
                return '继续起飞' // 绿色
            }
            break
          case 'CET7': // 劫炸机
            switch (row.result) {
              case 'R1' :
                return '快速撤离' // 黄色
              case 'R2' :
                return '紧急撤离' // 红色
              case 'R3' :
                return '公司决策' // 蓝色
            }
            break
        }
        return '当前事件正在处理中...'
      }

    }
  }
</script>

<style lang="less" scoped>
/deep/.el-drawer{
  margin: 0 !important;
  background: #262D40;
  height: 100vh;
  width: 600px;
  border-radius: 0 8px 8px 0;
  .el-drawer__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    color: #fff;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 20px;
  }
  .el-dialog__headerbtn{
    top: 22px;
  }
}
  .history-head{
    padding: 24px 16px;
    font-size: 24px;
    text-align: left;
    line-height: 20px;
  }
  .history-input{
    background: #131B33;
    width: calc(100% - 32px);
    margin: auto;
    height: 45px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    /deep/.el-input__inner{
      background: none;
      color: #fff;
    }
  }
  .history-bottom{
    padding: 24px;
    .history-laber:last-child{
      margin-bottom: 0;
    }
    .history-laber{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .history-left{
        opacity: 0.87;
        font-size: 14px;
      }
      .history-right{
        opacity: 0.9;
        font-size: 16px;
      }
      .history-right.active{
        color: #E07073;
      }
      .history-right.active2{
        color: #8EBF86;
      }
      .history-right.active3{
        color: #EBA967;
      }
      .history-right.active4{
        color: #2769EC;
      }
    }
  }
  .history-ul{
    padding: 16px;
    border-top: 1px solid #171E2F;
    margin-top: 20px;
    height: calc(100vh - 136px);
    padding-bottom: 0;
    box-sizing: border-box;
    overflow: auto;
    .history-li{
      background: #393F52;
      border: 1px solid #525F89;
      border-radius: 16px;
      margin-bottom: 16px;
      .history-top{
        display: flex;
        padding: 24px;
        justify-content: space-between;
        border-bottom: 1px solid #000000;
        .history-text{
          text-align: left;
          width: 370px;
          .history-h{
            font-size: 16px;
            color: rgba(255, 255, 255, 0.87);
            margin-bottom: 10px;
            span{
              margin-left: 10px ;
              padding: 3px;
border-radius: 2px;
              font-size: 14px;
            }
            span.red{
              background-color: #E9463C;
            }
            span.green{
              background-color: #5CBE85;
            }
            span.blue{
              background-color: #3F7CF6;
            }
            span.yellow{
              background-color: #EBA967;
            }
          }
          .history-p{
            color: rgba(255, 255, 255, 0.7);
            font-size: 12px;
          }
        }
        .history-bt.active{
          background: #1F60C1;
        }
        .history-bt{
          background: #4E5569;
          border-radius: 8px;
          font-size: 14px;
          cursor: pointer;
          padding: 0 20px;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/HistoryListDialog.vue